// extracted by mini-css-extract-plugin
export var footer = "_ht-0";
export var inherit = "_ht-1";
export var input = "_ht-2";
export var modalContent = "_ht-3";
export var quillEditor = "_ht-4";
export var subtitle = "_ht-5";